let activeInCart = [];
// Shipping and minimum order amounts
let freeShippingThreshold = window.siteWideSettings.freeShippingThreshold;
const isCustomerLoggedIn = window.siteWideSettings.isCustomerLoggedIn;
const enableGwpDollarThreshold =
window.siteWideSettings.enableGwpDollarThreshold;
const dollarThresholdGwpCustomersOnly = window.siteWideSettings.dollarThresholdGwpCustomersOnly;
const enableTieredGwpDollarThreshold =
window.siteWideSettings.enableTieredGwpDollarThreshold;
const tieredThresholdGwpCustomersOnly = window.siteWideSettings.tieredThresholdGwpCustomersOnly;
const enableAutoSampleCart = window.siteWideSettings.enableAutoSampleCart;
const autoSampleCustomersOnly = window.siteWideSettings.autoSampleCustomersOnly;
const singleEntryVariantId = window.siteWideSettings.singleEntryVariantId;
const multipleEntryVariantId = window.siteWideSettings.multipleEntryVariantId;
const enableProductBasedGWP = window.siteWideSettings.enableProductBasedGwp;
const productBasedGwpCustomersOnly = window.siteWideSettings.productBasedGwpCustomersOnly;
const enableEstablishmentGwp = window.siteWideSettings.enableEstablishmentGwp;
const establishmentGwpThreshold = window.siteWideSettings.establishmentGwpThreshold;
const customerEstablishmentLevel = window.siteWideSettings.customerEstablishmentLevel;
const enableSpendAndChooseGwp = window.siteWideSettings.enableSpendAndChooseGwp;
const spendAndChooseCustomersOnly = window.siteWideSettings.spendAndChooseCustomersOnly;
const enableSamplesSelection = window.siteWideSettings.enableSamplesSelection;
const samplesSelectionCustomersOnly = window.siteWideSettings.samplesSelectionCustomersOnly;
const samplesSelectionLimit = window.siteWideSettings.samplesSelectionLimit || 2;
const samplesSelectionVariantIDs = window.siteWideSettings.samplesSelectionVariantIDs || [];
const spendAndChooseTier1Threshold = window.siteWideSettings.spendAndChooseTier1Threshold;
const spendAndChooseTier1Products = window.siteWideSettings.spendAndChooseTier1Products;
const spendAndChooseTier1Message = window.siteWideSettings.spendAndChooseTier1Message;
const spendAndChooseTier1TicketIDs = window.siteWideSettings.spendAndChooseTier1TicketIDs;
const spendAndChooseTier2Threshold = window.siteWideSettings.spendAndChooseTier2Threshold;
const spendAndChooseTier2VariantIDs = window.siteWideSettings.spendAndChooseTier2VariantIDs;
const spendAndChooseTier2Message = window.siteWideSettings.spendAndChooseTier2Message;
const spendAndChooseTier2TicketIDs = window.siteWideSettings.spendAndChooseTier2TicketIDs;
const spendAndChooseSuccessMessage = window.siteWideSettings.spendAndChooseSuccessMessage;
 
let productBasedGwpVariantId;
let autoSampleID;
let singleGwpVariantId;
let singleGwpBonusVariantId;
let singleGwpThreshold;
let singleGwpMessage;
let tier1GwpThreshold;
let tier1GwpVariantIDs;
let tier1GwpMessage;
let tier2GwpThreshold;
let tier2GwpVariantIDs;
let tier2GwpMessage;
let gwpThreshold;
let gwpVariantId;
let gwpMessage;
let productBasedGwpTrigger100;
let productBasedGwpTrigger50;
let productBasedProgress;
let collectionVariantIds;
let establishmentGwpVariantIds;

if (enableAutoSampleCart) {
autoSampleID = window.siteWideSettings.autoSampleID;
}

if (enableGwpDollarThreshold) {
singleGwpThreshold = window.siteWideSettings.singleGwpThreshold;
singleGwpVariantId = window.siteWideSettings.singleGwpVariantId;
singleGwpBonusVariantId = window.siteWideSettings.singleGwpBonusVariantId;
singleGwpMessage = window.siteWideSettings.singleGwpMessage;
}

if (enableProductBasedGWP) {
productBasedGwpVariantId = window.siteWideSettings.productBasedGwpVariantId;
productBasedGwpTrigger100 = window.siteWideSettings.productBasedGwpTrigger100;
productBasedGwpTrigger50 = window.siteWideSettings.productBasedGwpTrigger50;
collectionVariantIds = window.siteWideSettings.productBasedGwpCollectionProducts;
}

if (enableEstablishmentGwp && customerEstablishmentLevel) {
// Get the variant IDs based on customer's level, plus all-levels products
const levelVariantIds = [];

// Mapping of customer levels to their respective product arrays
const levelMapping = {
    penthouse: window.siteWideSettings.establishmentGwpPenthouse,
    lounge: window.siteWideSettings.establishmentGwpLounge,
    lift: window.siteWideSettings.establishmentGwpLift,
    ground_floor: window.siteWideSettings.establishmentGwpGroundFloor
};

// Add level-specific products
const levelProducts = levelMapping[customerEstablishmentLevel];
if (levelProducts) {
    levelVariantIds.push(...levelProducts);
}

// Add all-levels products for everyone
if (window.siteWideSettings.establishmentGwpAllLevels) {
    levelVariantIds.push(...window.siteWideSettings.establishmentGwpAllLevels);
}

establishmentGwpVariantIds = levelVariantIds;
}

if (enableTieredGwpDollarThreshold) {
tier1GwpThreshold = window.siteWideSettings.tier1GwpThreshold;
tier1GwpVariantIDs = window.siteWideSettings.tier1GwpVariantIDs;
tier1GwpMessage = window.siteWideSettings.tier1GwpMessage;
tier2GwpThreshold = window.siteWideSettings.tier2GwpThreshold;
tier2GwpVariantIDs = window.siteWideSettings.tier2GwpVariantIDs;
tier2GwpMessage = window.siteWideSettings.tier2GwpMessage;
}

(function (window, document) {
"use strict";
var AgileCart = function (options) {
    var defaults = {
    // Defaults configuration
    cartTrigger: ".js-go-cart-trigger",
    cartHeaderTotal: ".header-cart__total",
    cartDrawer: ".js-go-cart-drawer",
    cartDrawerContent: ".js-go-cart-drawer-content",
    cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
    cartDrawerFooter: ".cart-drawer__footer",
    cartDrawerClose: ".js-go-cart-drawer-close",
    cartRemoveAll: ".cart-drawer__remove-all",
    cartPageContent: ".cart__items--wrapper",
    cartTotalWrapper: ".cart-totals-wrapper",
    cartOverlay: ".js-go-cart-overlay",
    cartCount: ".js-go-cart-counter",
    addToCart: ".js-go-cart-add-to-cart",
    addToCartSearch: ".quick-add__submit-search",
    removeFromCart: ".go-cart-item__remove",
    itemQuantity: ".js-go-cart-quantity",
    itemQuantityPlus: ".js-go-cart-quantity-plus",
    itemQuantityMinus: ".js-go-cart-quantity-minus",
    cartCollection: ".go-cart__collection",
    shippingThresholdTextWrapper: ".threshold__text",
    numberElement: ".cart-shipping__num",
    freeShippingProgress: ".cart-shipping__numOuter",
    cartSuccessMessage: ".cart-shipping__success",
    cartProgressBar: ".cart-shippingThreshold__progress",
    cartShippingWrapper: ".cart-shipping__wrapper",
    cartShippingDisclaimer: ".cart-reserve__wrapper",
    liquorContainer: ".liquor-check-age",
    minSpendWrapper: ".min-cart-spend",
    moneyFormat: "${{amount}}",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
};

AgileCart.prototype.init = function () {
    this.cartTrigger = document.querySelector(this.settings.cartTrigger);
    this.cartHeaderTotal = document.querySelector(
    this.settings.cartHeaderTotal
    );
    this.cartDrawer = document.querySelector(this.settings.cartDrawer);
    this.cartDrawerContent = document.querySelector(
    this.settings.cartDrawerContent
    );
    this.cartDrawerSubTotal = document.querySelector(
    this.settings.cartDrawerSubTotal
    );
    this.cartDrawerFooter = document.querySelector(
    this.settings.cartDrawerFooter
    );
    this.cartDrawerClose = document.querySelector(
    this.settings.cartDrawerClose
    );
    this.cartPageContent = document.querySelector(
    this.settings.cartPageContent
    );
    this.cartTotalWrapper = document.querySelector(
    this.settings.cartTotalWrapper
    );
    this.cartOverlay = document.querySelector(this.settings.cartOverlay);
    this.cartCount = document.querySelector(this.settings.cartCount);
    this.addToCart = document.querySelector(this.settings.addToCart);
    this.addToCartSearch = document.querySelector(
    this.settings.addToCartSearch
    );
    this.removeFromCart = document.querySelector(this.settings.removeFromCart);
    this.itemQuantity = document.querySelector(this.settings.itemQuantity);
    this.itemQuantityPlus = document.querySelector(
    this.settings.itemQuantityPlus
    );
    this.itemQuantityMinus = document.querySelector(
    this.settings.itemQuantityMinus
    );
    this.cartCollection = document.querySelector(this.settings.cartCollection);
    this.shippingThresholdTextWrapper = document.querySelectorAll(
    this.settings.shippingThresholdTextWrapper
    );
    this.numberElement = document.querySelectorAll(this.settings.numberElement);
    this.freeShippingProgress = document.querySelectorAll(
    this.settings.freeShippingProgress
    );
    this.cartSuccessMessage = document.querySelector(
    this.settings.cartSuccessMessage
    );
    this.cartProgressBar = document.querySelectorAll(
    this.settings.cartProgressBar
    );
    this.cartShippingWrapper = document.querySelector(
    this.settings.cartShippingWrapper
    );
    this.cartShippingDisclaimer = document.querySelector(
    this.settings.cartShippingDisclaimer
    );
    this.minSpendWrapper = document.querySelectorAll(
    this.settings.minSpendWrapper
    );
    this.liquorContainer = document.querySelector(
    this.settings.liquorContainer
    );
    this.updatingMessage = document.querySelector('.cart-updating-message__text');
    this.isAddingSpendChooseGift = false;
    this.fetchCart();
};

// Helper function to set updating message
AgileCart.prototype.setUpdatingMessage = function(message) {
    if (this.updatingMessage) {
        this.updatingMessage.textContent = message;
    }
};

AgileCart.prototype.bindEvents = function () {
    var self = this;

    this.cartTrigger.addEventListener("click", function () {
    document.body.classList.add("overflow-hidden");
    self.fetchCart();
    self.openCartOverlay();
    });

    this.cartOverlay.addEventListener("click", function () {
    document.body.classList.remove("overflow-hidden");
    self.closeCartOverlay();
    });

    this.cartDrawerClose.addEventListener("click", function () {
    document.body.classList.remove("overflow-hidden");
    self.closeCartOverlay();
    });

    document.addEventListener("click", function (event) {
    if (event.target.matches(self.settings.cartRemoveAll)) {
        if (confirm("Are you sure?")) {
        self.removeAll();
        if (isCartTemplate) {
            self.cartPageContent.classList.add("updating-cart");
        } else {
            self.cartDrawerContent.classList.add("updating-cart");
        }
        self.renderBlankCartDrawer();
        }
    }
    });

    document.addEventListener(
    "click",
    function (event) {
        // Check if the clicked element matches the add-to-cart selector
        if (event.target.matches(self.settings.addToCart)) {
        event.preventDefault();
        self.cartDrawerContent.classList.add("updating-cart");

        // Get the form associated with the clicked button and add the item to the cart
        var formElement = event.target.closest("form");
        var formId = formElement.getAttribute("id");
        
        // Check if adding a Tier 1 Spend & Choose gift
        const isSpendChooseTier1 = formElement.closest('.cart_spend-choose-tier1');
        
        if (isSpendChooseTier1) {
            // Prevent double-adding with a flag
            if (self.isAddingSpendChooseGift) {
                console.log("Already adding Spend & Choose gift, skipping duplicate");
                return;
            }
            
            self.isAddingSpendChooseGift = true;
            console.log("Adding Tier 1 Spend & Choose gift");
            self.setUpdatingMessage('Adding your gift...');
            
            // Close popup immediately before adding
            self.cartDrawer.classList.remove("show-spend-choose-selections", "show-spend-choose-tier1", "show-spend-choose-tier2");
            
            // Get form data and add the property
            var formData = new FormData(formElement);
            const variantId = formData.get('id');
            const quantity = formData.get('quantity') || 1;
            
            const itemsToAdd = [{
                id: parseInt(variantId),
                quantity: parseInt(quantity),
                properties: {
                    _SpendChooseTier: "tier1",
                },
            }];
            
            // Add ALL Tier 1 tickets if configured
            if (spendAndChooseTier1TicketIDs && spendAndChooseTier1TicketIDs.length > 0) {
                console.log("Adding Tier 1 gift with ALL tickets:", spendAndChooseTier1TicketIDs);
                self.setUpdatingMessage('Adding your gift + festival tickets...');
                spendAndChooseTier1TicketIDs.forEach((ticketId) => {
                    itemsToAdd.push({
                        id: ticketId,
                        quantity: 1,
                        properties: {
                            _SpendChooseTier: "tier1",
                            _FestivalTicket: "true",
                        },
                    });
                });
            }
            
            self.addItemsToCart(itemsToAdd);
            
            // Reset flag after a delay
            setTimeout(() => {
                self.isAddingSpendChooseGift = false;
            }, 2000);
        } else {
            self.addItemToCart(formId);
        }

        // Close gift selection popup if adding from it
        if (formElement.closest('.cart_gift-selections')) {
            self.cartDrawer.classList.remove("show-gift-selections", "show-tier1", "show-tier2");
        }
        // Close spend & choose popup if adding from it (already done above for Tier 1)
        if (!isSpendChooseTier1 && formElement.closest('.cart_spend-choose-selections')) {
            self.cartDrawer.classList.remove("show-spend-choose-selections", "show-spend-choose-tier1", "show-spend-choose-tier2");
        }

        // Remove the 'show-quick-view' class from the body
        document.body.classList.remove("show-quick-view");

        // Find any open quickview popups and remove the 'open-qv-popup' class
        document
            .querySelectorAll(".quickview-popup.open-qv-popup")
            .forEach((popup) => {
            popup.classList.remove("open-qv-popup");
            });
        }
    },
    false
    );

    document.addEventListener(
    "click",
    function (event) {
        if (event.target.matches(self.settings.removeFromCart)) {
        if (event.target.matches(".bundle-remove")) {
            self.cartDrawerContent.classList.add("updating-cart");
            var bundleKeys = event.target.getAttribute("data-bundle-keys"); // Assuming bundleID is stored in a data attribute
            self.removeItemsByKeys(bundleKeys);
        } else {
            self.cartDrawerContent.classList.add("updating-cart");
            var lineItemElement = event.target.closest(".go-cart-item__single");
            var lineNumber = lineItemElement.getAttribute("data-line");
            self.removeItem(lineNumber);
        }
        }
    },
    false
    );

    document.addEventListener(
    "click",
    function (event) {
        if (event.target.matches(self.settings.itemQuantityPlus)) {
        self.cartDrawerContent.classList.add("updating-cart");
        var itemElement = event.target.closest(".go-cart-item__single");
        let maxQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).max
        );
        var line = itemElement.getAttribute("data-line");
        var currentQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).value,
            10
        );
        if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
            self.changeItemQuantity(line, currentQuantity + 1);
        } else {
            console.error("Maximum quantity reached");
            itemElement.querySelector(".product-error__container").innerHTML =
            "Maximum quantity in cart";

            setTimeout(function () {
            itemElement.querySelector(".product-error__container").innerHTML =
                "";
            }, 2000);
        }
        }

        if (event.target.matches(self.settings.itemQuantityMinus)) {
        self.cartDrawerContent.classList.add("updating-cart");
        var itemElement = event.target.closest(".go-cart-item__single");
        var line = itemElement.getAttribute("data-line");
        var currentQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).value,
            10
        );
        // Check if currentQuantity is greater than 1
        if (currentQuantity > 1) {
            self.changeItemQuantity(line, currentQuantity - 1);
        } else {
            self.removeItem(line);
        }
        }
    },
    false
    );

    function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
        args = arguments;
        var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
    }

    // Close gift selection popup when clicking on overlay
    this.cartDrawer.addEventListener("click", function (event) {
    if (event.target === self.cartDrawer && 
        self.cartDrawer.classList.contains("show-gift-selections")) {
        self.cartDrawer.classList.remove("show-gift-selections", "show-tier1", "show-tier2");
    }
    if (event.target === self.cartDrawer && 
        self.cartDrawer.classList.contains("show-spend-choose-selections")) {
        self.cartDrawer.classList.remove("show-spend-choose-selections", "show-spend-choose-tier1", "show-spend-choose-tier2");
    }
    });
    
    // Free Samples Selection - Add sample
    document.addEventListener("click", function (event) {
      if (event.target.matches(".js-add-sample") || event.target.closest(".js-add-sample")) {
        const btn = event.target.matches(".js-add-sample") ? event.target : event.target.closest(".js-add-sample");
        if (btn.classList.contains("disabled")) return;
        
        const variantId = parseInt(btn.getAttribute("data-variant-id"));
        console.log("Adding free sample:", variantId);
        
        self.cartDrawerContent.classList.add("updating-cart");
        self.addItemsToCart([{
          id: variantId,
          quantity: 1,
          properties: {
            _FreeSample: "true"
          }
        }]);
      }
    });
    
    // Free Samples Selection - Remove sample
    document.addEventListener("click", function (event) {
      if (event.target.matches(".js-remove-sample") || event.target.closest(".js-remove-sample")) {
        const btn = event.target.matches(".js-remove-sample") ? event.target : event.target.closest(".js-remove-sample");
        const variantId = parseInt(btn.getAttribute("data-variant-id"));
        console.log("Removing free sample:", variantId);
        
        self.cartDrawerContent.classList.add("updating-cart");
        
        // Fetch cart to find the item key
        fetch("/cart.js", { credentials: "same-origin", method: "GET" })
          .then(response => response.json())
          .then(cart => {
            const sampleItem = cart.items.find(item => 
              item.variant_id === variantId && 
              item.properties && 
              item.properties._FreeSample === "true"
            );
            
            if (sampleItem) {
              self.updateItemQuantity([{
                key: sampleItem.key,
                quantity: 0
              }]);
            } else {
              self.cartDrawerContent.classList.remove("updating-cart");
            }
          })
          .catch(error => {
            console.error("Error removing sample:", error);
            self.cartDrawerContent.classList.remove("updating-cart");
          });
      }
    });
};

(AgileCart.prototype.fetchCart = function () {
    console.log("fetchCart");
    let self = this;
    let productsInCartArray = [];
    let productUpdates = [];
    let currentCartValue = 0;
    let cartItemTotal = 0;
    let gwpToAdd = [];
    window
    .fetch("/cart.js", { credentials: "same-origin", method: "GET" })
    .then(function (response) {
        return response.json();
    })
    .then(function (cart) {
        currentCartValue = cart.total_price;
        cartItemTotal = cart.item_count;

        cart.items.forEach((item) => {
        const {
            title: itemTitle,
            variant_id: itemId,
            quantity: itemQuantity,
            key: itemKey,
            price: itemPrice,
            original_price: itemOriginalPrice,
            line_price: itemLinePrice,
            original_line_price: itemOriginalLinePrice,
            final_price: itemFinalPrice,
            final_line_price: itemFinalLinePrice,
            product_type: itemType,
            properties: itemProperties,
        } = item;

        productsInCartArray.push({
            title: itemTitle,
            id: itemId,
            price: itemPrice,
            originalPrice: itemOriginalPrice || itemPrice,
            line_price: itemLinePrice,
            original_line_price: itemOriginalLinePrice,
            final_price: itemFinalPrice,
            final_line_price: itemFinalLinePrice,
            key: itemKey,
            quantity: itemQuantity,
            properties: itemProperties || {},
        });
        });

        self.fetchHandler(cart, cartItemTotal, currentCartValue);
        self.freeShippingCalculator(currentCartValue);

        console.log(productsInCartArray);

        if (enableAutoSampleCart && (!autoSampleCustomersOnly || isCustomerLoggedIn)) {
        const autoSampleInCart = productsInCartArray.some(
            (item) => item.id === autoSampleID
        );
        const onlyAutoSampleInCart =
            autoSampleInCart && productsInCartArray.length === 1;

        if (currentCartValue > 0 && !onlyAutoSampleInCart) {
            if (!autoSampleInCart) {
            self.updateItemQuantity([{ id: autoSampleID, quantity: 1 }]);
            }
        } else {
            if (autoSampleInCart) {
            self.updateItemQuantity([{ id: autoSampleID, quantity: 0 }]);
            }
        }
        }

        if (enableGwpDollarThreshold && (!dollarThresholdGwpCustomersOnly || isCustomerLoggedIn)) {
        // Check for existing single GWP items in cart
        const singleGwpInCart = productsInCartArray.filter(
            (product) =>
            singleGwpVariantId.includes(product.id) &&
            product.properties &&
            product.properties["_GwpType"] === "single"
        );

        // Check for existing single GWP bonus variant items in cart (if it exists)
        const singleGwpBonusInCart = singleGwpBonusVariantId
            ? productsInCartArray.filter(
                (product) =>
                singleGwpBonusVariantId.includes(product.id) &&
                product.properties &&
                product.properties["_GwpType"] === "single"
            )
            : [];

        // Below threshold - remove gifts if present
        if (currentCartValue < singleGwpThreshold) {
            if (singleGwpInCart.length > 0) {
            self.cartDrawerContent.classList.add("updating-cart");
            const itemsToRemove = singleGwpInCart.map((item) => ({
                id: item.id,
                quantity: 0,
            }));
            self.updateItemQuantity(itemsToRemove);
            }

            if (singleGwpBonusVariantId && singleGwpBonusInCart.length > 0) {
            self.cartDrawerContent.classList.add("updating-cart");
            const bonusItemsToRemove = singleGwpBonusInCart.map((item) => ({
                id: item.id,
                quantity: 0,
            }));
            self.updateItemQuantity(bonusItemsToRemove);
            }
        }
        // Above threshold - add gifts if not present
        else if (currentCartValue >= singleGwpThreshold) {
            // Add missing regular GWP items
            const missingGwpItems = singleGwpVariantId.filter(
            (variantId) =>
                !singleGwpInCart.some((item) => item.id === variantId)
            );

            if (missingGwpItems.length > 0) {
            self.cartDrawerContent.classList.add("updating-cart");
            const itemsToAdd = missingGwpItems.map((variantId) => ({
                id: variantId,
                quantity: 1,
                properties: {
                _GwpType: "single",
                },
            }));
            self.addItemsToCart(itemsToAdd);
            }

            // Add missing bonus GWP items
            if (singleGwpBonusVariantId) {
            const missingBonusItems = singleGwpBonusVariantId.filter(
                (variantId) =>
                !singleGwpBonusInCart.some((item) => item.id === variantId)
            );

            if (missingBonusItems.length > 0) {
                self.cartDrawerContent.classList.add("updating-cart");
                const bonusItemsToAdd = missingBonusItems.map((variantId) => ({
                id: variantId,
                quantity: 1,
                properties: {
                    _GwpType: "single",
                },
                }));
                self.addItemsToCart(bonusItemsToAdd);
            }
            }
        }
        }

        if (enableTieredGwpDollarThreshold && (!tieredThresholdGwpCustomersOnly || isCustomerLoggedIn)) {
        // Add delay to let discount operations complete first
        setTimeout(() => {
            // Prevent execution if cart is already being updated to avoid loops
            if (self.cartDrawerContent.classList.contains("updating-cart")) {
            console.log("Exiting: cart is updating");
            return;
            }

            console.log("=== TIERED GWP DEBUG START ===");

            // Find all GWP products in cart (both tier1 and tier2)
            const allTier1GwpsInCart = productsInCartArray.filter((product) =>
            tier1GwpVariantIDs.includes(product.id)
            );
            const allTier2GwpsInCart = productsInCartArray.filter((product) =>
            tier2GwpVariantIDs.includes(product.id)
            );

            // Calculate customer spending: cart total minus script-added GWP line prices
            let gwpTotal = 0;
            productsInCartArray.forEach((product) => {
            const isGwpVariant =
                tier1GwpVariantIDs.includes(product.id) ||
                tier2GwpVariantIDs.includes(product.id);
            const isScriptAddedGwp =
                isGwpVariant &&
                product.properties &&
                product.properties["_Tier"];

            if (isScriptAddedGwp) {
                gwpTotal += product.line_price;
            }
            });

            const customerSpending = currentCartValue - gwpTotal;
            console.log(`Tiered GWP - Total value: ${currentCartValue}, GWP value: ${gwpTotal}, Customer spending: ${customerSpending}`);

            console.log(
            `Customer's actual spending (including manual GWP purchases): ${customerSpending}`
            );

            // Find GWPs with proper tier attributes
            const tier1GwpWithAttr = allTier1GwpsInCart.filter(
            (product) =>
                product.properties && product.properties["_Tier"] === "tier1"
            );

            const tier2GwpWithAttr = allTier2GwpsInCart.find(
            (product) =>
                product.properties && product.properties["_Tier"] === "tier2"
            );

            // Below tier1 threshold - remove all GWPs
            if (customerSpending < tier1GwpThreshold) {
            console.log(
                "BELOW TIER1 THRESHOLD - REMOVING ALL GWPS"
            );

            const giftsToRemove = [];

            // Remove all tier1 GWPs (with _Tier attributes)
            allTier1GwpsInCart.forEach((product) => {
                if (product.properties && product.properties["_Tier"]) {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                console.log(
                    `Marking tier1 GWP for removal: ${product.title}`
                );
                }
            });

            // Remove all tier2 GWPs (with _Tier attributes)
            allTier2GwpsInCart.forEach((product) => {
                if (product.properties && product.properties["_Tier"]) {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                console.log(
                    `Marking tier2 GWP for removal: ${product.title}`
                );
                }
            });

            if (giftsToRemove.length > 0) {
                console.log("Removing gifts:", giftsToRemove);
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
            }
            }
            // Between tier1 and tier2 threshold - should have tier1 only
            else if (
            customerSpending >= tier1GwpThreshold &&
            customerSpending < tier2GwpThreshold
            ) {
            console.log("QUALIFIES FOR TIER1 ONLY");

            // Remove any script-added tier2 GWPs first
            const tier2GwpsToRemove = allTier2GwpsInCart.filter(
                (product) =>
                product.properties && product.properties["_Tier"] === "tier2"
            );

            if (tier2GwpsToRemove.length > 0) {
                const giftsToRemove = [];
                tier2GwpsToRemove.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                console.log(
                    `Marking script-added tier2 GWP for removal: ${product.title}`
                );
                });

                console.log("REMOVING SCRIPT-ADDED TIER2 PRODUCTS");
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
                return; // Exit to prevent tier1 logic from running same time
            }

            // Check if we need to add tier1 GWP
            const hasTier1GwpWithAttr = allTier1GwpsInCart.some(
                (product) =>
                product.properties && product.properties["_Tier"] === "tier1"
            );

            if (
                !hasTier1GwpWithAttr &&
                tier1GwpVariantIDs &&
                tier1GwpVariantIDs.length > 0
            ) {
                // No tier1 GWP with proper attribute - add one
                console.log("ADDING TIER1 GWP:", tier1GwpVariantIDs[0]);
                self.cartDrawerContent.classList.add("updating-cart");
                self.addItemsToCart([
                {
                    id: tier1GwpVariantIDs[0],
                    quantity: 1,
                    properties: {
                    _Tier: "tier1",
                    },
                },
                ]);
            } else {
                console.log("TIER1 GWP already properly configured");
            }
            }
            // Above tier2 threshold - should have tier2 only
            else if (customerSpending >= tier2GwpThreshold) {
            console.log("QUALIFIES FOR TIER2 ONLY");

            // Remove any script-added tier1 GWPs first
            const tier1GwpsToRemove = allTier1GwpsInCart.filter(
                (product) =>
                product.properties && product.properties["_Tier"] === "tier1"
            );

            if (tier1GwpsToRemove.length > 0) {
                const giftsToRemove = [];
                tier1GwpsToRemove.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                console.log(
                    `Marking script-added tier1 GWP for removal: ${product.title}`
                );
                });

                console.log("REMOVING SCRIPT-ADDED TIER1 PRODUCTS");
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
                return; // Exit to prevent tier2 logic from running same time
            }

            // Check if we need to add tier2 GWP
            const hasTier2GwpWithAttr = allTier2GwpsInCart.some(
                (product) =>
                product.properties && product.properties["_Tier"] === "tier2"
            );

            if (
                !hasTier2GwpWithAttr &&
                tier2GwpVariantIDs &&
                tier2GwpVariantIDs.length > 0
            ) {
                // No tier2 GWP with proper attribute - add one
                console.log("ADDING TIER2 GWP:", tier2GwpVariantIDs[0]);
                self.cartDrawerContent.classList.add("updating-cart");
                self.addItemsToCart([
                {
                    id: tier2GwpVariantIDs[0],
                    quantity: 1,
                    properties: {
                    _Tier: "tier2",
                    },
                },
                ]);
            } else {
                console.log("TIER2 GWP already properly configured");
            }
            }

            console.log("=== TIERED GWP DEBUG END ===");

            self.updateThresholdTiers(customerSpending);
        }, 1000); // 1 second delay to let discounts process
        }

        if (enableProductBasedGWP && (!productBasedGwpCustomersOnly || isCustomerLoggedIn)) {
        console.log("Checking GWP conditions");

        // First check if any products are from the trigger collection
        let hasCollectionProduct = false;
        if (collectionVariantIds && collectionVariantIds.length > 0) {
            // Log for debugging
            console.log("Collection Variant IDs:", collectionVariantIds);
            console.log("Cart Products:", productsInCartArray);

            hasCollectionProduct = productsInCartArray.some((cartItem) =>
            collectionVariantIds.includes(cartItem.id)
            );

            // Log the result
            console.log("Has Collection Product:", hasCollectionProduct);
        }

        // If no collection match, check for size triggers
        let has100mlProduct = false;
        let has50mlProduct = false;

        if (!hasCollectionProduct) {
            if (productBasedGwpTrigger100) {
            const products100ml = productsInCartArray.filter((item) =>
                item.title.includes("100ml")
            );
            has100mlProduct = products100ml.length > 0;
            }

            if (productBasedGwpTrigger50) {
            const products50ml = productsInCartArray.filter((item) =>
                item.title.includes("50ml")
            );
            has50mlProduct = products50ml.length > 0;
            }
        }

        // Check for existing GWPs
        const productBasedGWPs = productsInCartArray.filter(
            (product) =>
            product.id === productBasedGwpVariantId &&
            product.properties &&
            product.properties["_GwpType"] === "single"
        );

        // Set the progress variable based on whether we have GWPs in the cart
        let productBasedProgress = productBasedGWPs.length > 0;

        // Determine if we need to add a GWP based on the conditions
        const shouldAddGwp =
            hasCollectionProduct ||
            (productBasedGwpTrigger100 && has100mlProduct) ||
            (productBasedGwpTrigger50 && has50mlProduct);

        console.log("Should Add GWP:", shouldAddGwp);
        console.log("Existing GWPs:", productBasedGWPs.length);

        if (shouldAddGwp) {
            // Only add a GWP if there isn't one already in the cart
            if (productBasedGWPs.length === 0) {
            self.cartDrawerContent.classList.add("updating-cart");
            self.addItemsToCart([
                {
                id: productBasedGwpVariantId,
                quantity: 1,
                properties: { _GwpType: "single" },
                },
            ]);
            productBasedProgress = true;
            }
        } else {
            // No qualifying products - remove any gifts
            if (productBasedGWPs.length > 0) {
            self.cartDrawerContent.classList.add("updating-cart");
            const removeItems = productBasedGWPs.map((item) => ({
                key: item.key,
                quantity: 0,
            }));
            self.updateItemQuantity(removeItems);
            productBasedProgress = false;
            }
        }

        // Call the free shipping calculator with the current status at the end
        self.freeShippingCalculator(currentCartValue, productBasedProgress);
        }

        // Establishment GWP logic
        if (enableEstablishmentGwp && customerEstablishmentLevel && establishmentGwpVariantIds && establishmentGwpVariantIds.length > 0) {
        console.log("Checking Establishment GWP conditions");
        console.log("Customer Level:", customerEstablishmentLevel);
        console.log("Threshold:", establishmentGwpThreshold);
        console.log("Current Cart Value:", currentCartValue);
        
        // Find existing establishment GWPs in cart
        const establishmentGwpsInCart = productsInCartArray.filter(
            (product) =>
            establishmentGwpVariantIds.includes(product.id) &&
            product.properties &&
            product.properties["_GwpType"] === "establishment"
        );

        console.log("Establishment GWPs in cart:", establishmentGwpsInCart.length);

        // Check if cart meets threshold
        if (currentCartValue >= establishmentGwpThreshold) {
            // Above threshold - add missing GWPs
            const missingGwpItems = establishmentGwpVariantIds.filter(
            (variantId) =>
                !establishmentGwpsInCart.some((item) => item.id === variantId)
            );

            if (missingGwpItems.length > 0) {
            console.log("Adding Establishment GWPs:", missingGwpItems);
            self.cartDrawerContent.classList.add("updating-cart");
            const itemsToAdd = missingGwpItems.map((variantId) => ({
                id: variantId,
                quantity: 1,
                properties: {
                _GwpType: "establishment",
                _EstablishmentLevel: customerEstablishmentLevel
                },
            }));
            self.addItemsToCart(itemsToAdd);
            } else {
            console.log("All Establishment GWPs already in cart");
            }
        } else {
            // Below threshold - remove any establishment GWPs
            if (establishmentGwpsInCart.length > 0) {
            console.log("Removing Establishment GWPs - threshold not met");
            self.cartDrawerContent.classList.add("updating-cart");
            const itemsToRemove = establishmentGwpsInCart.map((item) => ({
                key: item.key,
                quantity: 0,
            }));
            self.updateItemQuantity(itemsToRemove);
            }
        }
        }

        // Free Samples Selection logic - Auto-remove samples if no regular products
        if (enableSamplesSelection && (!samplesSelectionCustomersOnly || isCustomerLoggedIn)) {
          console.log("=== SAMPLES SELECTION DEBUG START ===");
          
          // Find all free samples in cart
          const freeSamplesInCart = productsInCartArray.filter(
            (product) => product.properties && product.properties["_FreeSample"] === "true"
          );
          
          // Find all non-sample products in cart
          const regularProductsInCart = productsInCartArray.filter(
            (product) => !product.properties || product.properties["_FreeSample"] !== "true"
          );
          
          console.log(`Free samples in cart: ${freeSamplesInCart.length}`);
          console.log(`Regular products in cart: ${regularProductsInCart.length}`);
          
          // If no regular products but samples exist, remove all samples
          if (regularProductsInCart.length === 0 && freeSamplesInCart.length > 0) {
            console.log("No regular products in cart - removing all free samples");
            self.cartDrawerContent.classList.add("updating-cart");
            const samplesToRemove = freeSamplesInCart.map((item) => ({
              key: item.key,
              quantity: 0,
            }));
            self.updateItemQuantity(samplesToRemove);
          }
          
          // Check if customer has more samples than allowed
          if (freeSamplesInCart.length > samplesSelectionLimit) {
            console.log(`Too many samples (${freeSamplesInCart.length}/${samplesSelectionLimit}) - removing excess`);
            self.cartDrawerContent.classList.add("updating-cart");
            const excessSamples = freeSamplesInCart.slice(samplesSelectionLimit);
            const samplesToRemove = excessSamples.map((item) => ({
              key: item.key,
              quantity: 0,
            }));
            self.updateItemQuantity(samplesToRemove);
          }
          
          console.log("=== SAMPLES SELECTION DEBUG END ===");
        }

        // Spend & Choose GWP logic
        if (enableSpendAndChooseGwp && (!spendAndChooseCustomersOnly || isCustomerLoggedIn)) {
        setTimeout(() => {
            if (self.cartDrawerContent.classList.contains("updating-cart")) {
            console.log("Exiting Spend & Choose: cart is updating, will retry in 500ms");
            // Retry after cart finishes updating
            setTimeout(() => {
                if (!self.cartDrawerContent.classList.contains("updating-cart")) {
                    console.log("Cart update complete, re-running Spend & Choose logic");
                    self.fetchCart();
                }
            }, 500);
            return;
            }

            console.log("=== SPEND & CHOOSE GWP DEBUG START ===");
            console.log("Current cart value:", currentCartValue);

            // Find ALL Spend & Choose items (main gifts + tickets) by checking the property
            const allSpendChooseTier1InCart = productsInCartArray.filter((product) =>
                product.properties && product.properties["_SpendChooseTier"] === "tier1"
            );
            const allSpendChooseTier2InCart = productsInCartArray.filter((product) =>
                product.properties && product.properties["_SpendChooseTier"] === "tier2"
            );

            console.log("Total products in cart:", productsInCartArray.length);
            console.log("Tier 1 Spend & Choose items found:", allSpendChooseTier1InCart.map(p => p.title));
            console.log("Tier 2 Spend & Choose items found:", allSpendChooseTier2InCart.map(p => p.title));

            // Calculate customer spending: cart total minus Spend & Choose GWP line prices
            let spendChooseTotal = 0;
            allSpendChooseTier1InCart.forEach((product) => {
                spendChooseTotal += product.line_price;
            });
            allSpendChooseTier2InCart.forEach((product) => {
                spendChooseTotal += product.line_price;
            });
            console.log("Total Spend & Choose line_price:", spendChooseTotal);

            const customerSpending = currentCartValue - spendChooseTotal;

            console.log(`Spend & Choose - Customer spending: ${customerSpending}`);
            console.log(`Tier 1 items in cart (including tickets): ${allSpendChooseTier1InCart.length}`);
            console.log(`Tier 2 items in cart (including tickets): ${allSpendChooseTier2InCart.length}`);

            // Remove any existing classes
            self.cartDrawer.classList.remove(
            "show-spend-choose-selections",
            "show-spend-choose-tier1",
            "show-spend-choose-tier2"
            );

            // Below tier1 threshold - remove all gifts (including tickets)
            if (customerSpending < spendAndChooseTier1Threshold) {
            console.log("BELOW SPEND & CHOOSE TIER1 - REMOVING ALL");

            const giftsToRemove = [];
            // Remove all Tier 1 items (main gift + tickets)
            allSpendChooseTier1InCart.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
            });
            // Remove all Tier 2 items (main gift + tickets)
            allSpendChooseTier2InCart.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
            });

            if (giftsToRemove.length > 0) {
                console.log(`Removing ${giftsToRemove.length} Spend & Choose items`);
                self.setUpdatingMessage('Removing gifts...');
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
            }

            // Show normal checkout button (below threshold)
            const checkoutBtn = document.querySelector('.checkout-button');
            const selectGiftBtn = document.querySelector('.select-gift-button');
            if (checkoutBtn) checkoutBtn.style.display = 'flex';
            if (selectGiftBtn) selectGiftBtn.style.display = 'none';
            }
            // Between tier1 and tier2 - CUSTOMER CHOOSES
            else if (
            customerSpending >= spendAndChooseTier1Threshold &&
            customerSpending < spendAndChooseTier2Threshold
            ) {
            console.log("QUALIFIES FOR SPEND & CHOOSE TIER1 - CUSTOMER CHOOSES");

            // Remove any tier2 gifts (including tickets) first
            if (allSpendChooseTier2InCart.length > 0) {
                const giftsToRemove = [];
                allSpendChooseTier2InCart.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                });
                console.log(`Removing ${giftsToRemove.length} Tier 2 items (downgraded from Tier 2)`);
                self.setUpdatingMessage('Removing Tier 2 gifts...');
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
                return;
            }

            const tier1MainGiftInCart = allSpendChooseTier1InCart.find(item => 
                !item.properties || !item.properties._FestivalTicket
            );
            const tier1TicketsInCart = allSpendChooseTier1InCart.filter(item => 
                item.properties && item.properties._FestivalTicket === "true"
            );

            console.log("Tier 1 main gift in cart:", tier1MainGiftInCart ? "YES" : "NO");
            console.log("Tier 1 tickets in cart:", tier1TicketsInCart.length);

            if (!tier1MainGiftInCart) {
                console.log("SHOWING SPEND & CHOOSE GIFT SELECTION");
                self.cartDrawer.classList.add("show-spend-choose-selections", "show-spend-choose-tier1");
                const checkoutBtn = document.querySelector('.checkout-button');
                const selectGiftBtn = document.querySelector('.select-gift-button');
                if (checkoutBtn) checkoutBtn.style.display = 'none';
                if (selectGiftBtn) selectGiftBtn.style.display = 'flex';
            } else {
                console.log("SPEND & CHOOSE TIER1 GIFT already selected");
                
                // Check for duplicate tickets (keep only one of each ticket variant)
                if (tier1TicketsInCart.length > 0) {
                    const ticketCounts = {};
                    tier1TicketsInCart.forEach((ticket) => {
                        if (!ticketCounts[ticket.id]) {
                            ticketCounts[ticket.id] = [];
                        }
                        ticketCounts[ticket.id].push(ticket);
                    });
                    
                    const ticketsToRemove = [];
                    Object.keys(ticketCounts).forEach((ticketId) => {
                        const tickets = ticketCounts[ticketId];
                        if (tickets.length > 1) {
                            console.log(`REMOVING DUPLICATE TIER 1 TICKETS for variant ${ticketId} - keeping only one`);
                            // Keep first, remove rest
                            tickets.slice(1).forEach((ticket) => {
                                ticketsToRemove.push({ key: ticket.key, quantity: 0 });
                            });
                        }
                    });
                    
                    if (ticketsToRemove.length > 0) {
                        self.setUpdatingMessage('Removing duplicate tickets...');
                        self.cartDrawerContent.classList.add("updating-cart");
                        self.updateItemQuantity(ticketsToRemove);
                        return;
                    }
                }
                
                const checkoutBtn = document.querySelector('.checkout-button');
                const selectGiftBtn = document.querySelector('.select-gift-button');
                if (checkoutBtn) checkoutBtn.style.display = 'flex';
                if (selectGiftBtn) selectGiftBtn.style.display = 'none';
            }
            }
            // Above tier2 - AUTO-ADD TIER 2 and REMOVE TIER 1
            else if (customerSpending >= spendAndChooseTier2Threshold) {
            console.log("QUALIFIES FOR SPEND & CHOOSE TIER2 - AUTO ADD");

            // Remove ALL tier1 gifts (including tickets) first
            if (allSpendChooseTier1InCart.length > 0) {
                const giftsToRemove = [];
                allSpendChooseTier1InCart.forEach((product) => {
                giftsToRemove.push({ key: product.key, quantity: 0 });
                });
                console.log(`REMOVING ${giftsToRemove.length} SPEND & CHOOSE TIER1 ITEMS (upgraded to Tier 2)`);
                self.setUpdatingMessage('Upgrading to Tier 2 gifts...');
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(giftsToRemove);
                return;
            }

            const tier2MainGiftsInCart = allSpendChooseTier2InCart.filter(item => 
                !item.properties || !item.properties._FestivalTicket
            );
            const tier2TicketsInCart = allSpendChooseTier2InCart.filter(item => 
                item.properties && item.properties._FestivalTicket === "true"
            );

            console.log("Tier 2 main gifts in cart:", tier2MainGiftsInCart.length);
            console.log("Tier 2 tickets in cart:", tier2TicketsInCart.length);

            const itemsToAdd = [];

            // Check which Tier 2 gifts are missing and add them
            if (spendAndChooseTier2VariantIDs && spendAndChooseTier2VariantIDs.length > 0) {
                const tier2MainGiftIdsInCart = tier2MainGiftsInCart.map(item => item.id);
                const missingTier2Gifts = spendAndChooseTier2VariantIDs.filter(
                    variantId => !tier2MainGiftIdsInCart.includes(variantId)
                );
                
                if (missingTier2Gifts.length > 0) {
                    console.log("AUTO-ADDING MISSING SPEND & CHOOSE TIER2 GIFTS:", missingTier2Gifts);
                    
                    // Add MISSING products from the Tier 2 list
                    missingTier2Gifts.forEach((variantId) => {
                        itemsToAdd.push({
                            id: variantId,
                            quantity: 1,
                            properties: {
                                _SpendChooseTier: "tier2",
                            },
                    });
                });
                
                // Also add ALL missing Tier 2 tickets
                if (spendAndChooseTier2TicketIDs && spendAndChooseTier2TicketIDs.length > 0) {
                    const tier2TicketIdsInCart = tier2TicketsInCart.map(item => item.id);
                    const missingTier2Tickets = spendAndChooseTier2TicketIDs.filter(
                        ticketId => !tier2TicketIdsInCart.includes(ticketId)
                    );
                    
                    if (missingTier2Tickets.length > 0) {
                        console.log("AUTO-ADDING MISSING Tier 2 festival tickets:", missingTier2Tickets);
                        missingTier2Tickets.forEach((ticketId) => {
                            itemsToAdd.push({
                                id: ticketId,
                                quantity: 1,
                                properties: {
                                    _SpendChooseTier: "tier2",
                                    _FestivalTicket: "true",
                                },
                            });
                        });
                    }
                }
            }
        }
        
        // Check for duplicate tickets (keep only one of each ticket variant)
        if (tier2TicketsInCart.length > 0) {
            const ticketCounts = {};
            tier2TicketsInCart.forEach((ticket) => {
                if (!ticketCounts[ticket.id]) {
                    ticketCounts[ticket.id] = [];
                }
                ticketCounts[ticket.id].push(ticket);
            });
            
            const ticketsToRemove = [];
            Object.keys(ticketCounts).forEach((ticketId) => {
                const tickets = ticketCounts[ticketId];
                if (tickets.length > 1) {
                    console.log(`REMOVING DUPLICATE TIER 2 TICKETS for variant ${ticketId} - keeping only one`);
                    // Keep first, remove rest
                    tickets.slice(1).forEach((ticket) => {
                        ticketsToRemove.push({ key: ticket.key, quantity: 0 });
                    });
                }
            });
            
            if (ticketsToRemove.length > 0) {
                self.setUpdatingMessage('Removing duplicate tickets...');
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity(ticketsToRemove);
                return;
            }
        }

            if (itemsToAdd.length > 0) {
                console.log("Total items to add for Tier 2:", itemsToAdd);
                self.setUpdatingMessage('Adding Tier 2 gifts...');
                self.cartDrawerContent.classList.add("updating-cart");
                self.addItemsToCart(itemsToAdd);
            }

            // Show normal checkout button (in Tier 2)
            const checkoutBtn = document.querySelector('.checkout-button');
            const selectGiftBtn = document.querySelector('.select-gift-button');
            if (checkoutBtn) checkoutBtn.style.display = 'flex';
            if (selectGiftBtn) selectGiftBtn.style.display = 'none';
            }

            console.log("=== SPEND & CHOOSE GWP DEBUG END ===");
        }, 1200); // Slightly delayed to avoid conflicts
        } else {
        // Spend & Choose not enabled or customer doesn't qualify - show normal checkout button
        const checkoutBtn = document.querySelector('.checkout-button');
        const selectGiftBtn = document.querySelector('.select-gift-button');
        if (checkoutBtn) checkoutBtn.style.display = 'flex';
        if (selectGiftBtn) selectGiftBtn.style.display = 'none';
        }

        //self.cartHeaderTotal.innerHTML = self.formatMoney(currentCartValue,self.moneyFormat);
    })
    .catch(function (response) {
        console.error("Error while fetching the cart:", response);
    });
}),
    (AgileCart.prototype.formatMoney = function (amount) {
    console.log("formatMoney");
    return this.settings.moneyFormat.replace("{{amount}}", amount);
    });

(AgileCart.prototype.fetchHandler = function (
    cart,
    cartItemTotal,
    currentCartValue
) {
    this.cartItemCount(cartItemTotal);
    if (cart.item_count === 0) {
    this.renderBlankCartDrawer();
    } else {
    //this.cartCollection.classList.add("is-invisible");
    this.renderDrawerCart(cart, currentCartValue);
    this.cartDrawerFooter.classList.remove("is-invisible");
    }
}),
    (AgileCart.prototype.cartItemCount = function (cartItemTotal) {
    this.cartCount.innerHTML = cartItemTotal;
    }),
    (AgileCart.prototype.addItemToCart = function (formId) {
    console.log("addItemToCart");
    var self = this,
        formElement = document.querySelector("#" + formId); // Correctly target the form by its ID

    if (!formElement) {
        console.error("Form not found: #" + formId);
        return; // Exit if form not found
    }

    // Create FormData object from the form
    var formData = new FormData(formElement);
    console.log(formData);

    // Convert FormData to URL-encoded string
    var formDataObj = new URLSearchParams();
    formData.forEach(function (value, key) {
        formDataObj.append(key, value);
    });

    console.log(formDataObj.toString());

    window
        .fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formDataObj.toString(), // Use the URL-encoded string
        })
        .then(function (response) {
        return response.json();
        })
        .then(function (cartResponse) {
        self.openCartOverlay();
        self.fetchCart(); // Handle cart count update
        })
        .catch(function (error) {
        self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
        console.error("Error adding item to cart: ", error);
        });
    });

AgileCart.prototype.addItemsToCart = function (itemsArray) {
    console.log("addItemsToCart");
    var self = this;

    // Create an array to hold the line items
    var items = [];

    // Loop through each item in the array
    itemsArray.forEach(function (item) {
    var lineItem = {
        id: item.id,
        quantity: item.quantity,
        properties: item.properties,
    };

    // Add this line item to the items array
    items.push(lineItem);
    });

    // Prepare the data for the POST request
    const data = {
    items: items,
    };

    console.log("Data to send:", data);

    // Make a single fetch request to add all items in one call
    window
    .fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(data), // Use JSON format to send multiple line items
    })
    .then(function (response) {
        return response.json();
    })
    .then(function (cartResponse) {
        console.log("All items added to cart:", cartResponse);
        self.openCartOverlay();
        self.fetchCart(); // Fetch the updated cart after all items are added
    })
    .catch(function (error) {
        self.ajaxRequestFail(); // Handle request failures
        console.error("Error adding items to cart: ", error);
    });
};

AgileCart.prototype.addItemToCartSearch = function (wrapperId) {
    var self = this;

    // Find the hidden input within the wrapper
    var variantId = wrapperId;
    console.log(variantId);

    if (!variantId) {
    console.error("Variant ID input not found");
    return; // Exit if the variant input is not found
    }

    // Create an object to submit. Adjust the object structure as per your needs.
    var formDataObj = { id: variantId };

    window
    .fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formDataObj), // Use the object directly
    })
    .then(function (response) {
        return response.json();
    })
    .then(function (cartResponse) {
        self.fetchCart(); // Handle cart count update
    })
    .catch(function (error) {
        self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
        console.error("Error adding item to cart: ", error);
    });
};

AgileCart.prototype.changeItemQuantity = function (lineNumber, quantity) {
    console.log("changeItemQuantity");
    var self = this;
    window
    .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: quantity, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
    })
    .then(function (response) {
        return response.json();
    })
    .then(function () {
        return self.fetchCart();
    })
    .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error);
    });
};

AgileCart.prototype.updateItemQuantity = function (productUpdates) {
    console.log("updateItemQuantity");
    var self = this;

    const data = {
    updates: {},
    properties: {},
    };

    productUpdates.forEach((update) => {
    const { id, key, quantity, properties } = update;

    // If key is provided, use it; otherwise use id
    const updateKey = key || id;
    data.updates[updateKey] = quantity;

    if (properties) {
        data.properties[updateKey] = properties;
    }
    });

    // Set up the request options for the Fetch API
    const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
    };

    // Set up the URL for the Ajax API call
    const apiUrl = "/cart/update.js";

    // Make the API call using the Fetch API
    fetch(apiUrl, options)
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error(error))
    .finally(() => {
        self.openCartOverlay();
        self.fetchCart();
    });
};
AgileCart.prototype.removeItem = function (lineNumber) {
    console.log("removeItem");
    var self = this;
    window
    .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: 0, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
    })
    .then(function (response) {
        return response.json();
    })
    .then(function () {
        return self.fetchCart();
    })
    .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error); // Log the error instead of throwing it
    });
};

AgileCart.prototype.removeItemsByKeys = function (keys) {
    var self = this;

    // Split the keys into an array, as they are comma-separated
    const keyArray = keys.split(",").filter(Boolean); // Filter out any empty strings

    // Log keys for debugging purposes
    console.log("Keys to remove:", keyArray);

    // Create an object to hold the updates
    const updates = {};

    // Loop through each key in the array and set quantity to 0
    keyArray.forEach(function (key) {
    if (key && key.length > 0) {
        // Make sure it's not an empty string
        console.log("Adding item to remove with id:", key); // Log each id before removal
        updates[key.trim()] = 0; // Set quantity to 0 for this id
    } else {
        console.error("Invalid id encountered:", key);
    }
    });

    // Log the full update payload for debugging
    console.log("Sending batch remove request with updates:", updates);

    // Make a single fetch request to batch remove the items
    fetch("/cart/update.js", {
    method: "POST",
    credentials: "include",
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
        updates: updates, // Send the entire updates object in one request
    }),
    })
    .then(function (response) {
        if (!response.ok) {
        console.error("Failed to remove items, Response:", response);
        throw new Error("Failed to remove items");
        }
        return response.json();
    })
    .then(function (data) {
        console.log("Items successfully removed:", data);
        self.fetchCart(); // Fetch the updated cart after all items are removed
    })
    .catch(function (error) {
        console.error("Error removing items:", error);
    });
};

AgileCart.prototype.removeAll = function () {
    console.log("removeAll");
    var self = this;
    window
    .fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
    })
    .then(function (response) {
        return response.json();
    })
    .then(function () {
        return self.fetchCart();
    })
    .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error); // Log the error instead of throwing it
    });
};

// Utility methods
AgileCart.prototype.openCartOverlay = function () {
    document.body.classList.add("overflow-hidden");
    this.settings.cartDrawer.classList.add("is-open");
    this.settings.cartOverlay.classList.add("is-open");
};

AgileCart.prototype.closeCartOverlay = function () {
    document.body.classList.remove("overflow-hidden");
    this.settings.cartDrawer.classList.remove("is-open");
    this.settings.cartOverlay.classList.remove("is-open");
};

AgileCart.prototype.renderBlankCartDrawer = function () {
    console.log("renderBlankDrawer");
    this.cartDrawerContent.classList.add("empty-cart");
    //this.cartShippingDisclaimer.classList.add("is-invisible");
    if (this.cartCollection) {
    this.cartCollection.classList.remove("is-invisible");
    }
    this.cartDrawerFooter.classList.add("is-invisible");
    if (this.cartShippingWrapper) {
    this.cartShippingWrapper.classList.add("is-invisible");
    }
    //this.clearCart();
    this.cartDrawerContent.innerHTML = `
            <div class="go-cart__empty">
            <svg class="icon icon-cart" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            Your cart is empty
            <a href="/collections/scents" class="button button-solid">Continue Shopping</a>
            </div>
        `;
};

AgileCart.prototype.renderBlankCartPage = function () {
    console.log("renderBlankPage");
    var cartItems = document.querySelector(".cart__items");
    document.querySelector(".cart-totals-wrapper").style.display = "none";
    if (cartItems) {
    document.querySelector(".cart__items").style.display = "none";
    }
    document.querySelector(".cart__warnings").style.display = "flex";
    this.clearCart();
};

AgileCart.prototype.renderDrawerCart = function (cart, currentCartValue) {
    var emptyCartElement =
    this.cartDrawerContent.querySelector(".go-cart__empty");

    // Check if the element exists before trying to remove it
    if (emptyCartElement) {
    emptyCartElement.remove();
    }
    this.cartDrawerContent.classList.remove("empty-cart");
    if (this.cartShippingWrapper) {
    this.cartShippingWrapper.classList.remove("is-invisible");
    }
    var self = this;

    console.log("renderDrawerCart");

    // Show the overlay
    // Start simulating progress
    const progressBar = document.querySelector(".progress-bar-inner");
    if (progressBar) {
    progressBar.style.width = "0%"; // Reset progress
    setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress
    }

    Promise.all([
    fetch("/?section_id=cart-drawer-items", {
        method: "GET",
        headers: {
        "Content-Type": "text/html",
        },
    }),
    fetch("/?section_id=cart-drawer-footer", {
        method: "GET",
        headers: {
        "Content-Type": "text/html",
        },
    }),
    ])
    .then((responses) =>
        Promise.all(responses.map((response) => response.text()))
    )
    .then(([itemsHtml, footerHtml]) => {
        // Inject the new HTML into respective containers
        self.cartDrawerContent.innerHTML = itemsHtml;
        self.cartDrawerFooter.innerHTML = footerHtml;
        if (sessionStorage.getItem("hideLayeredOptions") === "true") {
        const layeredOptions = self.cartDrawerContent.querySelectorAll(
            ".layered-products-suggestions"
        );
        layeredOptions.forEach((element) => {
            element.style.display = "none";
        });
        }

        self.cartDrawerContent.classList.remove("updating-cart");
        if (progressBar) {
        progressBar.style.width = "0%";
        }

            // Initialize cart carousel after content is loaded
            setTimeout(() => {
                console.log('Attempting to initialize cart carousel...');
                console.log('window.initCartCarousel exists:', typeof window.initCartCarousel);
                console.log('Swiper exists:', typeof Swiper);
                
                if (typeof window.initCartCarousel === 'function') {
                    window.initCartCarousel();
                } else {
                    console.error('initCartCarousel function not found on window object');
                }
                
                // Initialize floating samples indicator
                self.initFloatingSamplesIndicator();
            }, 300);
        })
    .catch((error) => console.error("Error updating cart drawer:", error));
};

AgileCart.prototype.renderCartPage = function (cart) {
    var self = this;
    let updatedCartPrice = 0;
    console.log("renderCartPage");

    const progressBar = document.querySelector(".progress-bar");
    progressBar.style.width = "0%"; // Reset progress
    setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress

    fetch("/?section_id=cart-page-items", {
    method: "GET",
    headers: {
        "Content-Type": "text/html",
    },
    })
    .then((response) => response.text())
    .then((html) => {
        // Inject the new HTML into the cart drawer
        self.cartPageContent.innerHTML = html;

        self.cartPageContent.classList.remove("updating-cart");
        progressBar.style.width = "0%"; // Reset progress bar for the next update
        self.updateCartSubtotal();
        self.cartHeaderTotal.innerHTML = self.formatMoney(
        cart.total_price,
        self.moneyFormat
        );
        const liquorAgeCheck = document.querySelector(".liquor-check-age");
        if (hasLiquor) {
        liquorAgeCheck.classList.add("show-liquor-age-check");
        } else {
        liquorAgeCheck.classList.remove("show-liquor-age-check");
        }
    })
    .catch((error) => console.error("Error updating cart drawer:", error));
};

AgileCart.prototype.updateCartSubtotal = function () {
    console.log("updateCartSubtotal");
    var self = this;

    fetch("/?section_id=cart-totals")
    .then((response) => response.text())
    .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const checkoutElement = doc.getElementById("checkout");

        // Inject the modified HTML into the totals wrapper
        document.querySelector(".totals-wrapper").innerHTML =
        doc.body.innerHTML;
    })
    .catch((error) => console.error("Error updating cart subtotal:", error));
};

AgileCart.prototype.openCartOverlay = function () {
    this.cartDrawer.classList.add("is-open");
    this.cartOverlay.classList.add("is-open");
};

AgileCart.prototype.closeCartOverlay = function () {
    this.cartDrawer.classList.remove("is-open");
    this.cartOverlay.classList.remove("is-open");
};

AgileCart.prototype.removeItemAnimation = function (element) {
    if (element) element.classList.add("is-invisible");
};

AgileCart.prototype.clearCart = function () {
    console.log("clearCart");
    this.cartDrawerContent.innerHTML = "";
};

// Free Shipping Calculator
AgileCart.prototype.freeShippingCalculator = function (
    currentCartValue,
    productBasedProgress
) {
    var self = this;
    var percentage;
    var newProgressNum;
    console.log(productBasedProgress);

    // Convert currentCartValue from cents to dollars for display
    let displayValue = currentCartValue / 100;

    if (enableProductBasedGWP) {
    if (productBasedProgress == true) {
        document.querySelector(".cart-shipping__numOuter").style.display = "none";
        self.cartSuccessMessage.style.display = "block";
        percentage = 100;
        self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
        });
        document
        .querySelectorAll(".cart-shippingThreshold__bar img")
        .forEach(function (el) {
            el.setAttribute("style", `left: ${percentage}%;`);
        });
    } else {
        percentage = 0;
        document.querySelector(".cart-shipping__numOuter").style.display =
        "block";
        self.cartSuccessMessage.style.display = "none";
        self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
        });
        document
        .querySelectorAll(".cart-shippingThreshold__bar img")
        .forEach(function (el) {
            el.setAttribute("style", `left: ${percentage}%;`);
        });
    }
    }

    if (currentCartValue < freeShippingThreshold) {
    percentage = (currentCartValue / freeShippingThreshold) * 100;
    newProgressNum = (
        (freeShippingThreshold - currentCartValue) /
        100
    ).toFixed(2);

    document.querySelector(
        ".free-shipping__wrapper .threshold__text"
    ).style.display = "inline";
    document.querySelector(".free-shipping__success").style.display = "none";
    } else {
    percentage = 100;
    newProgressNum = 0;
    document.querySelector(
        ".free-shipping__wrapper .threshold__text"
    ).style.display = "none";
    document.querySelector(".free-shipping__success").style.display = "block";
    }

    document
    .querySelectorAll(".free-shippingThreshold__progress")
    .forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
    });
    document
    .querySelectorAll(".free-shippingThreshold__bar img")
    .forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
    });

    document.querySelectorAll(".free-shipping__num").forEach(function (el) {
    el.textContent = "$" + newProgressNum;
    });

    document.querySelector(".free-shipping__numOuter").style.display =
    currentCartValue >= freeShippingThreshold ? "none" : "block";

    // Hide all GWP wrappers first
    const allGwpWrappers = document.querySelectorAll('.cart-shipping__wrapper');
    allGwpWrappers.forEach(wrapper => {
      if (!wrapper.classList.contains('free-shipping-element') && 
          !wrapper.classList.contains('free-shipping__wrapper') &&
          !wrapper.classList.contains('promotion-bar-element')) {
        wrapper.classList.add('hide-cart-element');
      }
    });

    // Show the active GWP system
    if (enableTieredGwpDollarThreshold && (!tieredThresholdGwpCustomersOnly || isCustomerLoggedIn)) {
      const tieredWrappers = document.querySelectorAll('.tiered-threshold-wrapper');
      tieredWrappers.forEach(wrapper => wrapper.classList.remove('hide-cart-element'));
    } else if (enableGwpDollarThreshold && (!dollarThresholdGwpCustomersOnly || isCustomerLoggedIn)) {
      const singleWrapper = document.querySelector('.single-threshold-wrapper');
      if (singleWrapper) singleWrapper.classList.remove('hide-cart-element');
    } else if (enableSpendAndChooseGwp && (!spendAndChooseCustomersOnly || isCustomerLoggedIn)) {
      const spendChooseWrapper = document.querySelector('.spend-choose-wrapper');
      if (spendChooseWrapper) spendChooseWrapper.classList.remove('hide-cart-element');
    } else if (enableProductBasedGWP && (!productBasedGwpCustomersOnly || isCustomerLoggedIn)) {
      const productWrapper = document.querySelector('.cart-shipping__wrapper:not(.tiered-threshold-wrapper):not(.single-threshold-wrapper):not(.spend-choose-wrapper):not(.free-shipping-element)');
      if (productWrapper) productWrapper.classList.remove('hide-cart-element');
    }

    if (enableTieredGwpDollarThreshold) {
    // Calculate percentage based on tier2 threshold (100%)
    percentage = (currentCartValue / tier2GwpThreshold) * 100;

    if (currentCartValue < tier1GwpThreshold) {
        // Haven't reached tier1 yet
        newProgressNum = ((tier1GwpThreshold - currentCartValue) / 100).toFixed(
        2
        );
        document.querySelector(
        ".tiered-threshold-wrapper .threshold__text"
        ).innerHTML = " " + tier1GwpMessage;
        self.cartSuccessMessage.style.display = "none";
    } else if (currentCartValue < tier2GwpThreshold) {
        // Between tier1 and tier2
        newProgressNum = ((tier2GwpThreshold - currentCartValue) / 100).toFixed(
        2
        );
        document.querySelector(".tiered-threshold-wrapper .threshold__text").innerHTML = " " + tier2GwpMessage;
        document.querySelector(".tiered-threshold-wrapper .cart-shipping__success").style.display = "none";
    } else {
        // Reached tier2
        newProgressNum = 0;
        percentage = 100;
        self.cartSuccessMessage.style.display = "block";
    }

    // Add visual marker for tier1 threshold
    const tier1Percentage = (tier1GwpThreshold / tier2GwpThreshold) * 100;
    self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
    });
    document
        .querySelectorAll(".cart-shippingThreshold__bar img")
        .forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
        });
    } else if (enableGwpDollarThreshold) {
    // Single GWP logic
    if (currentCartValue < singleGwpThreshold) {
        percentage = (currentCartValue / singleGwpThreshold) * 100;
        newProgressNum = ((singleGwpThreshold - currentCartValue) /100).toFixed(2);

    document.querySelector(".single-threshold-wrapper .threshold__text").innerHTML = " " + singleGwpMessage;
    document.querySelector(".single-threshold-wrapper .cart-shipping__success").style.display = "none";
    } else {
        percentage = 100;
        newProgressNum = 0;
        document.querySelector(".single-threshold-wrapper .cart-shipping__success").style.display = "block";
    }

    self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
    });
    document
        .querySelectorAll(".cart-shippingThreshold__bar img")
        .forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
        });
    } else if (enableSpendAndChooseGwp) {
    // Spend & Choose GWP logic
    percentage = (currentCartValue / spendAndChooseTier2Threshold) * 100;

    if (currentCartValue < spendAndChooseTier1Threshold) {
        // Haven't reached tier1 yet
        newProgressNum = ((spendAndChooseTier1Threshold - currentCartValue) / 100).toFixed(2);
        const tier1Text = document.querySelector(".spend-choose-wrapper .threshold__text");
        if (tier1Text) tier1Text.innerHTML = " " + spendAndChooseTier1Message;
        const successMsg = document.querySelector(".spend-choose-wrapper .cart-shipping__success");
        if (successMsg) successMsg.style.display = "none";
    } else if (currentCartValue < spendAndChooseTier2Threshold) {
        // Between tier1 and tier2
        newProgressNum = ((spendAndChooseTier2Threshold - currentCartValue) / 100).toFixed(2);
        const tier2Text = document.querySelector(".spend-choose-wrapper .threshold__text");
        if (tier2Text) tier2Text.innerHTML = " " + spendAndChooseTier2Message;
        const successMsg = document.querySelector(".spend-choose-wrapper .cart-shipping__success");
        if (successMsg) successMsg.style.display = "none";
    } else {
        // Reached tier2
        newProgressNum = 0;
        percentage = 100;
        const successMsg = document.querySelector(".spend-choose-wrapper .cart-shipping__success");
        if (successMsg) successMsg.style.display = "block";
    }

    self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
    });
    document
        .querySelectorAll(".cart-shippingThreshold__bar img")
        .forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
        });
    }

    self.numberElement.forEach(function (el) {
    el.textContent = "$" + newProgressNum;
    });

    self.freeShippingProgress.forEach(function (el) {
    if (enableTieredGwpDollarThreshold) {
        el.style.display =
        currentCartValue >= tier2GwpThreshold ? "none" : "block";
    } else if (enableGwpDollarThreshold) {
        el.style.display =
        currentCartValue >= singleGwpThreshold ? "none" : "block";
    } else if (enableSpendAndChooseGwp) {
        el.style.display =
        currentCartValue >= spendAndChooseTier2Threshold ? "none" : "block";
    }
    });
};

// Floating Samples Indicator
AgileCart.prototype.initFloatingSamplesIndicator = function () {
    const samplesSection = document.querySelector('.cart-samples-selection');
    const floatingIndicator = document.getElementById('floatingSamplesIndicator');
    const cartContent = document.querySelector('.js-go-cart-drawer-content');
    
    if (!samplesSection || !floatingIndicator || !cartContent) {
        return;
    }
    
    // Function to check if samples section is visible
    const checkSamplesVisibility = () => {
        const contentRect = cartContent.getBoundingClientRect();
        const samplesRect = samplesSection.getBoundingClientRect();
        
        // Check if the samples section is below the visible area of the cart content
        const isHiddenBelow = samplesRect.top > contentRect.bottom - 50;
        
        if (isHiddenBelow) {
            floatingIndicator.classList.add('visible');
        } else {
            floatingIndicator.classList.remove('visible');
        }
    };
    
    // Initial check
    checkSamplesVisibility();
    
    // Check on scroll
    cartContent.addEventListener('scroll', checkSamplesVisibility);
    
    // Click to scroll to samples section
    floatingIndicator.addEventListener('click', () => {
        samplesSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        floatingIndicator.classList.remove('visible');
    });
};

AgileCart.prototype.updateThresholdTiers = function (currentCartValue) {
    // Convert currentCartValue from cents to dollars
    const cartValue = currentCartValue / 100;

    // Get all threshold-tiers elements
    const thresholdTiers = document.querySelectorAll(".threshold-tiers");

    thresholdTiers.forEach((tierContainer) => {
    const thresholdSpans = tierContainer.querySelectorAll("span");

    thresholdSpans.forEach((span) => {
        // Get the threshold value from the span text
        const thresholdValue = parseInt(span.textContent.replace("$", ""));

        // Add or remove class based on whether cart value exceeds threshold
        if (cartValue >= thresholdValue) {
        span.classList.add("threshold-met");
        } else {
        span.classList.remove("threshold-met");
        }
    });
    });
};

AgileCart.prototype.formatMoney = function (cents, format) {
    console.log();
    if (typeof cents === "string") {
    cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";

    function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
    ) {
    if (isNaN(number) || number == null) {
        return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
    );
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
    case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
    case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
};

function fetchJSONP(url, callbackParamName) {
    return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const callbackFunctionName = `jsonp_callback_${Math.round(
        100000 * Math.random()
    )}`;

    window[callbackFunctionName] = function (data) {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        resolve(data);
    };

    // Ensure correct URL formatting
    const separator = url.includes("?") ? "&" : "?";
    script.src = `${url}${separator}${callbackParamName}=${callbackFunctionName}`;
    script.onerror = function () {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        reject(new Error("Script load error"));
    };
    document.body.appendChild(script);
    });
}
// Make sure to implement ajaxRequestFail as needed

window.AgileCart = AgileCart;
})(window, document);

var agileCart = new AgileCart({});

// Spend & Choose checkout validation
document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('.go-cart-drawer__footer a[href="/checkout"]');
  if (!checkoutButton) return;

  checkoutButton.addEventListener('click', async function(e) {
    const settings = window.siteWideSettings || {};
    const enableSpendAndChooseGwp = settings.enableSpendAndChooseGwp;
    const spendAndChooseCustomersOnly = settings.spendAndChooseCustomersOnly || false;
    const isCustomerLoggedIn = settings.isCustomerLoggedIn || false;
    const spendAndChooseTier1Threshold = settings.spendAndChooseTier1Threshold;
    const spendAndChooseTier2Threshold = settings.spendAndChooseTier2Threshold;
    const spendAndChooseTier1Products = settings.spendAndChooseTier1Products || [];
    
    // Check if Spend & Choose is enabled and customer qualifies
    // If not, allow normal checkout
    if (!enableSpendAndChooseGwp) return;
    if (spendAndChooseCustomersOnly && !isCustomerLoggedIn) return;
    if (!spendAndChooseTier1Threshold || !spendAndChooseTier2Threshold) return;

    // Prevent default to validate first
    e.preventDefault();

    try {
      // Get current cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Calculate customer spending: cart total minus Spend & Choose GWP line prices
      let spendChooseTotal = 0;
      cart.items.forEach(item => {
        if (item.properties && item.properties["_SpendChooseTier"]) {
          spendChooseTotal += item.line_price;
        }
      });
      
      const customerSpending = cart.total_price - spendChooseTotal;

      console.log('Checkout validation - Customer spending:', customerSpending);

      // Check if in Tier 1 range
      if (customerSpending >= spendAndChooseTier1Threshold && 
          customerSpending < spendAndChooseTier2Threshold) {
        
        // Check if Tier 1 gift is selected
        const tier1GiftInCart = cart.items.some(item => 
          item.properties && 
          item.properties["_SpendChooseTier"] === "tier1"
        );

        if (!tier1GiftInCart) {
          console.log('Preventing checkout - no Tier 1 gift selected');
          
          // Show popup with warning
          const cartDrawer = document.querySelector('.go-cart__drawer');
          const popupContainer = document.querySelector('.cart_spend-choose-selections');
          
          if (cartDrawer && popupContainer) {
            cartDrawer.classList.add('show-spend-choose-selections', 'show-spend-choose-tier1');
            popupContainer.classList.add('show-warning');
            
            // Remove warning after a few seconds
            setTimeout(() => {
              popupContainer.classList.remove('show-warning');
            }, 3000);
          }
          return; // Stop here, don't proceed to checkout
        }
      }
      
      // If we get here, validation passed - proceed to checkout
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Error validating checkout:', error);
      // On error, allow checkout to proceed
      window.location.href = '/checkout';
    }
  });

});
